import useMediaQuery from "../hooks/useMediaQuery";
import { useFormCtx } from "./../FormContext";
import HiddenBackButton from "./HiddenBackButton";
import Button from "./Button";
import * as Const from "./../_Const";
import * as Helper from "./../_Helper";
import useScreenType from "../hooks/useScreenType";

function Navbar({
  customTitle,
  customSubtitle,
  onBackClick = null,
  modeShowTitle = true,
  modeShowSubtitle = true,
  useCustomTitle = false,
  fallbackText = "Vítejte v čekárně",
}) {
  const screenType = useScreenType();
  const isTerminal = Const.isTerminal();
  const lowerThan300 = useMediaQuery("(max-width: 300px)");
  const {
    terminalSettingsState,
    navigateHome,
    isDebugMode,
    handleDebug,
    getPageData,
    selectedPageIndex,
    showBackButton,
    navigateBackButtons,
    isDebugModeBackBtnClickable,
    navigateToServicePage,
    beep,
  } = useFormCtx();

  let titleText = isTerminal ? "" : terminalSettingsState?.mobileAppTitle;
  let subTitleText = isTerminal ? "" : terminalSettingsState?.mobileAppSubTitle;
  const titleLength = titleText?.length;
  const showNavigationBackButton = showBackButton();

  const isTitle = titleLength != 0;
  /*console.log(
    "title:",
    titleText,
    "customTitle:",
    customTitle,
    "subTitleText:",
    subTitleText,
    "customSubtitle:",
    customSubtitle,
    "isTitle:",
    isTitle,
    "isTerminal:",
    isTerminal,
    "useCustomTitle:",
    useCustomTitle
  );*/

  //jeli neco v customTitle a customSubtitle tak to vypln
  if (!Helper.isNullOrEmpty(customTitle)) {
    if (useCustomTitle) {
      titleText = customTitle;
    }
  }

  //jeli neco v customTitle a customSubtitle tak to vypln
  if (!Helper.isNullOrEmpty(customSubtitle)) {
    subTitleText = customSubtitle;
  }

  let title, subTitle;
  //default subtitle
  if (Helper.isNullOrEmpty(customSubtitle)) {
    if (isTitle) {
      subTitleText = fallbackText;
    }
  }

  //jsouli dlouhe nazvy cekarny 20+ tak prohodit titlexsubTitle rotoze subTitle ma mensi pismo
  const limit = isTerminal ? 50 : 20;
  if (titleLength > limit) {
    title = subTitleText;
    subTitle = titleText;
  } else {
    title = titleText;
    subTitle = subTitleText;
  }

  if (isTerminal && !useCustomTitle) {
    const page = getPageData(selectedPageIndex);
    if (page) {
      title = page.title;
      subTitle = page.subtitle;
    } else {
      title = titleText;
      subTitle = subTitleText;
    }
  }

  function getCssFor(what) {
    let css = "";
    if (screenType === Const.SCREEN_PHONE) {
      switch (what) {
        case "nav":
          css = "h-24";
          break;

        case "title":
          //jeli prehozen title do subtitle 20+ a titleLength je 40+ zmensi pismo
          let fontTitle;
          if (lowerThan300) {
            fontTitle = "text-2xl";
          } else {
            fontTitle = "text-3xl";
          }
          css = `${fontTitle}`;
          break;
        case "subtitle":
          //jeli prehozen title do subtitle 20+ a titleLength je 40+ zmensi pismo
          let font = titleLength >= 40 ? "text-base" : "text-xl";
          if (lowerThan300) {
            font = "text-base";
          } else {
            font = "text-xl";
          }
          css = `${font} mt-1`;
          break;
      }
    }
    //console.log(what, screenType, css);

    return css;
  }

  function handleHomeClick() {
    if (onBackClick) {
      onBackClick();
    } else {
      navigateHome();
    }
    beep();
  }

  if (screenType === Const.SCREEN_UNKNOWN) {
    return;
  }

  function handleBackButtonClick() {
    if (onBackClick) {
      onBackClick();
    }
    navigateBackButtons();
  }

  return (
    <nav
      className={`${getCssFor("nav")} scRPIV1:h-16 scRPIV2:h-24 scWaveShare:h-24 tvHD:h-24 tvFullHD:h-32 tv4K:h-64 bg-accent-dark place-content-center text-center drop-shadow-lg`}
    >
      {isTerminal && (
        <>
          <div className="absolute left-4 top-3">
            {/* zobrazi se pro stranku buttons pro vice lekaru */}
            {showNavigationBackButton && <HiddenBackButton onClick={handleBackButtonClick} visible={true} />}

            {/* zobrazi se pri hidden gestu pro debug mode */}
            {!showNavigationBackButton && (
              <HiddenBackButton onClick={handleHomeClick} visible={isDebugMode} isClickable={isDebugModeBackBtnClickable} setVisible={handleDebug} />
            )}
          </div>
        </>
      )}

      <h1
        className={`${getCssFor("nav")} scRPIV1:text-2xl scRPIV2:text-3xl scWaveShare:text-3xl tvHD:text-3xl tvFullHD:text-4xl tv4K:text-8xl font-bold text-white`}
      >
        {modeShowTitle && title}
      </h1>
      <p
        className={`${getCssFor("nav")} scRPIV1:mt-0 scRPIV1:text-base scRPIV2:mt-1 scRPIV2:text-xl scWaveShare:mt-1 scWaveShare:text-xl tvHD:mt-1 tvHD:text-xl tvFullHD:mt-2 tvFullHD:text-2xl tv4K:mt-4 tv4K:text-4xl text-white font-light`}
      >
        {modeShowSubtitle && subTitle}
      </p>
    </nav>
  );
}

export default Navbar;
